import Header from '../standartComponents/header';
import css from './pricing.module.css';
import PayWall from './payWall';
import Policies from '../standartComponents/policies';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { pollSubscriptionStatus } from '../../lib/subscriptionStatusApi';
import { fetchPaymentHistory } from '../../lib/ordersApi';

const PricingPage = ({authUser}) => {
  const [plans, setPlans] = useState([]);
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [isPollingComplete, setIsPollingComplete] = useState(false);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axios.get('/api/billing/plans/', {
          withCredentials: true,
        });
        console.log('Fetched plans:', response.data);
        setPlans(response.data);
      } catch (error) {
        console.error('Error fetching plans:', error);
      }
    };

    fetchPlans();
  }, []);

  // Check subscription status on page load (after redirect from Monobank) - only if authenticated
  useEffect(() => {
    if (!authUser?.isAuthenticated) {
      setIsPollingComplete(true);
      return;
    }
    
    const checkSubscriptionOnLoad = async () => {
      console.log('Checking subscription status after potential Monobank redirect...');
      const result = await pollSubscriptionStatus();
      console.log('Final subscription status result:', result);
      
      // Update subscription state based on polling result - accept any status
      if (result && typeof result === 'object' && result.id) {
        setCurrentSubscription(result);
      }
      
      // Mark polling as complete
      setIsPollingComplete(true);
    };

    checkSubscriptionOnLoad();
  }, [authUser?.isAuthenticated]);

  // Fetch current subscription - only if authenticated and polling is complete
  useEffect(() => {
    if (!authUser?.isAuthenticated || !isPollingComplete) return;
    
    const fetchCurrentSubscription = async () => {
      try {
        const response = await axios.get('/api/billing/orders/', {
          withCredentials: true,
        });
        console.log('Current subscriptions:', response.data);
        // Get the most recent subscription (any status)
        // Only update if polling didn't already set a subscription
        if (!currentSubscription && response.data && response.data.length > 0) {
          setCurrentSubscription(response.data[0]);
        }
      } catch (error) {
        console.error('Error fetching current subscription:', error);
      }
    };

    fetchCurrentSubscription();
  }, [authUser?.isAuthenticated, isPollingComplete]);

  // Fetch payment history with a delay - only if authenticated
  useEffect(() => {
    if (!authUser?.isAuthenticated) return;
    
    const timer = setTimeout(() => {
      console.log('Fetching payment history...');
      fetchPaymentHistory();
    }, 1000);

    return () => clearTimeout(timer);
  }, [authUser?.isAuthenticated]);

  return (
    <div className={css.pricingPageCon}>
    <Header authUser={authUser} isPricing={true} />
    <PayWall style={{height: '100%'}} authUser={authUser} plans={plans} currentSubscription={currentSubscription} isPollingComplete={isPollingComplete} />
    <Policies />
    </div>
  )
}

export default PricingPage